import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import * as moment from 'vendors/moment-locale-th';

import { ActHttpService, ContentTypes, HeaderTypes } from '../act-http/act-http.service';
import { BudgetLimitModel, UserModel, UserSetting } from '../../model/user.model';
import { FeatureType, PurposeType, CLIENT_ID, Language } from '../../model/constant';

import { AffiliateService } from '../affiliate/affiliate.service';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { AuthenticationService } from 'app/services/authentication/authentication.service';
import { Billing } from '../../model/billing/billing.model';
import { EditProfileModel } from 'app/model/profile/edit-profile-model';
import { EncryptRequestPayload } from './payload/encrypt-request.payload';
import { Injectable } from '@angular/core';
import { LoginPayload } from './payload/login.payload';
import { LoginResponseModel } from '../../model/login/login-response.model';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { SearchFormModel } from '../../model/search-form-model';
import { Subject } from 'rxjs/Subject';
import { TranslatePipe } from 'app/pipes/translate.pipe';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { VerifyCompanyDomainPayload, VerifyCompanyDomainResponse } from './payload/verify-company-domain.payload';
import { VerifyUserExistModel } from '../../model/user/verify-user-exist-model';
import { environment } from '../../../environments/environment';
import { RegisterPayload } from './payload/register-payload';
import { Companies } from 'app/model/menu/companies';
import { CallingCode } from 'app/model/user/calling-code-model';
import { CompanyShareBudgetModel, GenerateBudgetCodeResponse } from 'app/model/shareBudget/company-share-budget.model';
import { Consent, PurposeByUserIdRequest, PurposeByUserIdResponse, UserSubmitConsentRequest } from 'app/model/user/consent-model';
import { UserSuggest } from 'app/model/user/user-suggest';
import { BookForTraveller } from 'app/model/checkout/guest-info.model';
import { landingUrl, redirectURIV2 } from 'environments/properties';

@Injectable()
export class UserService {

  private readonly cookieName = 'stf'; // tslint:disable-line
  public listCompany = [];
  // public user: any;
  private userSubject = new Subject<any>();
  private callingCodeList: CallingCode[];
  private checkedConsent = false;

  constructor(
    private actHttp: ActHttpService,
    private utilities: UtilitiesService,
    private authService: AuthenticationService,
    private appConfigService: AppConfigService,
    private affiliateService: AffiliateService,
    private translate: TranslatePipe,
  ) { }

  saveTokenAfterLogin(loginResponse: LoginResponseModel) {
    if (loginResponse.token) {
      this.authService.saveSsoToken(loginResponse.token);
    }
  }

  login(user: string, password: string, companyId: number = 0): Observable<boolean> {
    const payload = new LoginPayload();
    payload.username = user;
    payload.timestamp = moment().format("x");
    const options = this.actHttp.getRequestOptions(HeaderTypes.AUTHORIZATION_RANDOM_STR, ContentTypes.JSON, user, JSON.stringify(payload));
    payload.clientId = 1;
    payload.companyId = companyId;
    payload.password = password;
    return this.actHttp.rawPost(environment.endpoint.loginAuthen, JSON.stringify(payload), options)
      .map((response: Response) => {
        const loginResponse: LoginResponseModel = response.json().data;
        if (!!!loginResponse.token) {
          return false;
        }
        this.saveTokenAfterLogin(loginResponse);
        return true;
      })
      .catch(() => Observable.of(false));
  }

  logout(): void {
    this.authService.clearToken();
    window.location.href = `${redirectURIV2}/?lang=${this.appConfigService.getLanguage()}`;
  }

  updateFeature(): Observable<boolean> {
    return this.authService
      .saveUserFeature(this.authService.getToken(), this.authService.getUserInfo(), AuthenticationService.features);
  }

  getUser(redirect: boolean = true): UserModel {
    const user = (<UserModel>this.authService.getUserInfo());
    if (redirect && !user) {
      this.logout();
      return;
    }
    return user;
  }

  updateUser(user) {
    const currentUser = this.getUser();
    currentUser.fullName = user.fullName;
    currentUser.telephone = user.telephone;
    currentUser.countryCallingCode = user.countryCallingCode;
    currentUser.features = [];
    user.email && (currentUser.email = user.email);
    user.birthDate && (currentUser.birthdate = user.birthDate);
    user.timeOfBirth && (currentUser.timeOfBirth = user.timeOfBirth);
    const _user: any = { user: currentUser };
    this.authService.saveToken(_user);
    this.userSubject.next(_user);
  }

  getUserObs(): Observable<any> {
    return this.userSubject.asObservable();
  }

  getuserInfo(companyId?: number, taxAddress?: boolean): Observable<UserModel> {
    const id = companyId ? `companyId=${companyId}` : undefined;
    const tax = taxAddress ? `taxAddress=${taxAddress}` : undefined;
    let param

    if (id && tax) {
      param = `?${id}&${tax}`;
    } else if (!id && !tax) {
      param = '';
    } else {
      param = `?${id ? id : tax}`;
    }

    const url = `${environment.endpoint.userInfo}` + param;
    const option = this.authService.getRequestOptions(HeaderTypes.ACT_TOKEN);
    return this.actHttp.get(url, option).map((res: Response) => res.json().data);
  }

  editProfile(payload: any): Observable<EditProfileModel> {
    const options = this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN, ContentTypes.JSON, payload.email);
    return this.actHttp.put(environment.endpoint.editProfile.replace(':userId', payload.userId), JSON.stringify(payload), options)
      .map((res: Response) => res.json().data);
  }

  editProfileAllCompany(payload: any): Observable<EditProfileModel> {
    const options = this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN, ContentTypes.JSON, payload.email);
    return this.actHttp.put(environment.endpoint.editProfileAllCompany.replace(':userId', payload.userId), JSON.stringify(payload), options)
      .map((res: Response) => res.json().data);
  }

  verifyUserExistedAndCompany(email: string): Observable<VerifyUserExistModel> {
    let verifyUserExist = new VerifyUserExistModel();
    this.listCompany = [];
    return this.verifyUserExist(email)
      .map((res: any) => {
        this.listCompany = res.companyList;
        return verifyUserExist = res;
      });
  }

  verifyDomain(email: string): Observable<VerifyCompanyDomainResponse[]> {
    const payload = new VerifyCompanyDomainPayload();
    payload.email = email;
    payload.appId = CLIENT_ID.ASCENDTRAVEL;
    payload.timestamp = moment().format("x");
    const options = this.actHttp.getRequestOptions(HeaderTypes.AUTHORIZATION_RANDOM_STR, ContentTypes.JSON, email, JSON.stringify(payload));
    return this.actHttp.rawPost(environment.endpoint.companyDomain, JSON.stringify(payload), options).map((res) => res.json());
  }

  verifyUserExist(email: string): Observable<Response> {
    const payload = new EncryptRequestPayload();
    payload.username = email;
    payload.timestamp = moment().format("x");
    payload.clientId = 1;
    const options = this.actHttp.getRequestOptions(HeaderTypes.AUTHORIZATION_RANDOM_STR, ContentTypes.JSON, email, JSON.stringify(payload));
    return this.actHttp.rawPost(environment.endpoint.verifyUserExist, JSON.stringify(payload), options).map((res) => res.json().data);
  }

  verifyUserExistedAndLogin(email: string, password: string): Observable<boolean> {
    return this.verifyUserExist(email)
      .flatMap(res => {
        return this.login(email, password);
      });
  }

  registerMember(companyId: number, email: string, password: string, confirmPassword: string): Observable<Response> {
    const payload = new RegisterPayload(email, moment().format("x"), CLIENT_ID.ASCENDTRAVEL, companyId);
    payload.name = email;
    payload.password = password;
    payload.confirmPassword = confirmPassword;
    payload.clientId = CLIENT_ID.ASCENDTRAVEL;
    payload.lang = this.appConfigService.getLanguage();
    const options = this.actHttp.getRequestOptions(HeaderTypes.AUTHORIZATION_RANDOM_STR, ContentTypes.JSON, payload.username, JSON.stringify(payload));
    return this.actHttp.rawPost(environment.endpoint.registerMember, JSON.stringify(payload), options);
  }

  verifyRegisterEmail(token: string): Observable<any> {
    const payload = { token, lang: this.appConfigService.getLanguage(), clientId: CLIENT_ID.ASCENDTRAVEL };
    const options = this.actHttp.getRequestOptions(HeaderTypes.EXCLUDE_TOKEN, ContentTypes.JSON);
    return this.actHttp.rawPost(environment.endpoint.verifyRegisterEmail, JSON.stringify(payload), options);
  }

  insertJoinUs({ companyName, travellingExpense: companyTravelExpense, website: companyWebsite, email, name, contactNumber: phone, position }) {
    const [payload] = Array.from(arguments);
    payload.timestamp = moment().format("x");
    const options = this.actHttp.getRequestOptions(HeaderTypes.AUTHORIZATION_RANDOM_STR, ContentTypes.JSON, payload.username, JSON.stringify(payload));
    return this.actHttp.rawPost(environment.endpoint.insertJoinUs, JSON.stringify(payload), options);
  }

  changePassword(password: String, confirmPassword: String): Observable<any> {
    const options = this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN, ContentTypes.JSON);
    const payload = { password, confirmPassword };
    return this.actHttp.put(environment.endpoint.changePassword, JSON.stringify(payload), options);
  }

  resetPassword(token: String, password: String, confirmPassword: String): Observable<any> {
    const options = this.actHttp.getRequestOptions(HeaderTypes.EXCLUDE_TOKEN, ContentTypes.JSON);
    const payload = { password, confirmPassword, token, clientId: CLIENT_ID.ASCENDTRAVEL };
    return this.actHttp.rawPut(environment.endpoint.resetPassword, JSON.stringify(payload), options).map((res) => res.json());
  }

  forgotPassword(username: string): Observable<any> {
    const lang = this.appConfigService.getLanguage();
    let timestamp = moment().format("x");
    const payload = { username, lang, timestamp };
    const options = this.actHttp.getRequestOptions(HeaderTypes.AUTHORIZATION_RANDOM_STR, ContentTypes.JSON, username, JSON.stringify(payload));
    return this.actHttp.rawPost(environment.endpoint.sendEmailForgetPassword, JSON.stringify(payload), options);
  }

  sendEmailRegisterVerify(email: string) {
    const lang = this.appConfigService.getLanguage();
    let timestamp = moment().format("x");
    const payload = { email, lang, timestamp }
    const options = this.actHttp.getRequestOptions(HeaderTypes.AUTHORIZATION_RANDOM_STR, ContentTypes.JSON, payload.email, JSON.stringify(payload));
    return this.actHttp.rawPost(environment.endpoint.sendEmailRegisterVerify, JSON.stringify(payload), options);
  }

  editTaxAddress({ address, active, isDefault, title, taxNumber, userTaxAddressID }) {
    const options = this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN, ContentTypes.JSON);
    const [payload] = Array.from(arguments);
    return this.actHttp.post(environment.endpoint.editTaxAddress, JSON.stringify(payload), options);
  }

  addTaxAddress({ isDefault, active, title, address, taxNumber }) {
    const options = this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN, ContentTypes.JSON);
    const [payload] = Array.from(arguments);
    return this.actHttp.post(environment.endpoint.addTaxAddress, JSON.stringify(payload), options);
  }

  getBillingAddress(): Observable<Billing[]> {
    return this.actHttp.get(
      environment.endpoint.getBilling,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    )
      .map((res: Response) => res.json().data);
  }

  createBillingAddress(billing: Billing): Observable<Billing> {
    return this.actHttp.post(
      environment.endpoint.createBilling,
      billing,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    )
      .map((res: Response) => res.json().data);
  }

  updateBillingAddress(billing: Billing): Observable<Billing> {
    return this.actHttp.put(
      environment.endpoint.updateBilling,
      billing,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    )
      .map((res: Response) => res.json().data);
  }

  deleteBillingAddress(billing: Billing): Observable<Billing> {
    return this.actHttp.delete(
      environment.endpoint.deleteBilling.replace('{billingId}', billing.billingId.toString()),
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    )
      .map((res: Response) => res.json().data);
  }

  checkBudgetLimit(searchData: SearchFormModel): BudgetLimitModel {
    const budgetLimit = new BudgetLimitModel();
    const budgetLimitFeature = this.getUserFeature(FeatureType.ALLOW_LIMIT_BUDGET);

    if (searchData.purpose === PurposeType.work && budgetLimitFeature && budgetLimitFeature.allow && budgetLimitFeature.data && budgetLimitFeature.data.amount > 0) {
      budgetLimit.isLimitBudget = true;
      budgetLimit.budget = budgetLimitFeature.data.amount.toFixed(2);
      budgetLimit.description = this.translate.transform(`product-detail-budget-limit`)
        .replace(/{x}/gi, this.utilities.getPriceRangeFormatText(budgetLimit.budget));
    } else {
      budgetLimit.isLimitBudget = false;
    }
    return budgetLimit;
  }

  getUserFeature(featureName: String, ignoreError = false) {
    const user = this.getUser(!ignoreError);
    const feature = user && user.features.find(ft => ft.feature === featureName);
    return feature;
  }

  getAllCompanyUser(): Observable<Companies[]> {
    return this.actHttp.get(environment.endpoint.getAllCompanyUser, this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN))
      .map((res: Response) => res.json().data);
  }

  checkAllowToPayOverBudget() {
    const allowMultiPayment = this.getUserFeature(FeatureType.ALLOW_MULTI_PAYMENT) && this.getUserFeature(FeatureType.ALLOW_MULTI_PAYMENT).allow;
    const allowCreditTerms = this.getUserFeature(FeatureType.ALLOW_CREDIT_TERMS) && this.getUserFeature(FeatureType.ALLOW_CREDIT_TERMS).allow;
    const allowMultiPaymentCorporateFleet = this.getUserFeature(FeatureType.ALLOW_MULTI_PAYMENT_CORPORATE_FLEET) && this.getUserFeature(FeatureType.ALLOW_MULTI_PAYMENT_CORPORATE_FLEET).allow;
    const allowCorporateFleet = this.getUserFeature(FeatureType.ALLOW_CORPORATE_FLEET) && this.getUserFeature(FeatureType.ALLOW_CORPORATE_FLEET).allow;

    return allowMultiPayment && allowCreditTerms || allowMultiPaymentCorporateFleet && allowCorporateFleet;
  }

  getAcceptPrivacyNote() {
    return this.actHttp.get(environment.endpoint.getAcceptPrivacyNote, this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN))
      .map((res: Response) => res.json().data);
  }

  getCallingCode(): Observable<CallingCode[]> {
    return new Observable(subscriber => {
      if (this.callingCodeList) {
        subscriber.next(this.callingCodeList);
        subscriber.complete();
      } else {
        this.getCallingCodeFromAPI().subscribe(res => {
          this.callingCodeList = res;
          subscriber.next(this.callingCodeList);
          subscriber.complete();
        }, err => subscriber.error(err));
      }
    });
  }

  getCallingCodeFromAPI(): Observable<CallingCode[]> {
    return this.actHttp.get(
      environment.endpoint.getCallingCode,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    ).map((res: Response) => res.json().data);
  }

  postAcceptPrivacyNote(id) {
    const payload = { userId: id };
    return this.actHttp.post(environment.endpoint.getAcceptPrivacyNote, JSON.stringify(payload), this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN))
      .map((res: Response) => res);
  }

  getCompanyShareBudget(): Observable<CompanyShareBudgetModel[]> {
    return this.actHttp.get(
      environment.endpoint.companyShareBudget,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    ).map((res: Response) => res.json().data);
  }

  generateShareBudgetCode(companyId: number, regenerate: boolean): Observable<GenerateBudgetCodeResponse> {
    const url = `${environment.endpoint.generateBudgetCode}?companyId=${companyId}&regenerate=${regenerate}`;

    return this.actHttp.get(
      url,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    ).map((res: Response) => res.json().data);
  }

  getUserConsentDetail(userId: number, name: string, types: string, lang: string): Observable<Consent> {
    const url = environment.endpoint.getUserConsentDetail.replace(':userId', userId.toString()).replace(':name', name) + `?types=${types}&lang=${lang}`;
    return this.actHttp.get(
      url,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    ).map((res: Response) => res.json().data);
  }

  getConsentDetail(name: string, types: string, lang: string): Observable<Consent> {
    const url = environment.endpoint.getConsentDetail.replace(':name', name) + `?types=${types}&lang=${lang}`;
    return this.actHttp.rawGet(url).map((res: Response) => res.json().data);
  }

  updateConsent(userId: number, consentId: number, purposeIds: number[]): Observable<any> {
    const url = environment.endpoint.updateUserConsent.replace(':userId', userId.toString());
    const payload = new UserSubmitConsentRequest();
    payload.consentId = consentId;
    payload.purposeIds = purposeIds;
    return this.actHttp.post(
      url,
      JSON.stringify(payload),
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    ).map((res: Response) => res);
  }

  getPurposeByUserId(userId: number, name: string, lang: string): Observable<PurposeByUserIdResponse> {
    const url = environment.endpoint.getPurposeByUserId
      .replace(':userId', userId.toString())
      .replace(':name', name)
      + `?lang=${lang}`;

    return this.actHttp.get(
      url,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    ).map((res: Response) => res.json().data);
  }

  updatePurposeByUserId(userId: number, action: string, request: PurposeByUserIdRequest) {
    const url = environment.endpoint.updatePurposeByUserId
      .replace(':userId', userId.toString())
      .replace(':action', action);

    return this.actHttp.post(
      url,
      request,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    );
  }

  hideMessageCart(currentUser) {
    const budgetlimit = currentUser.features.filter(x => x.feature === FeatureType.ALLOW_LIMIT_BUDGET && x.allow)[0];
    const budgetlimitPerMonthPerYear = budgetlimit && budgetlimit.data && (budgetlimit.data.amountPerMonth || budgetlimit.data.amountPerYear);

    const corporateFleetMulti = currentUser.features.filter(x =>
      (x.feature === FeatureType.ALLOW_MULTI_PAYMENT_CORPORATE_FLEET && x.allow) ||
      (x.feature === FeatureType.ALLOW_CORPORATE_FLEET && x.allow)).length === 2;

    return !!budgetlimitPerMonthPerYear && corporateFleetMulti;
  }

  travellerSuggest(search: string): Observable<UserSuggest[]> {
    const queryParams = new URLSearchParams();
    queryParams.append(`queryText`, search);
    queryParams.append(`companyId`, this.getUser().companyId.toString());

    const url = `${environment.endpoint.travellerSuggest}?${queryParams}`;
    return this.actHttp.get(
      url,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    ).map((res: Response) => res.json().data);
  }

  travellerDetail(userId: number, companyId: number, searchId: string): Observable<BookForTraveller> {
    const url = `${environment.endpoint.travellerDetail}/${userId}?companyId=${companyId}&searchId=${searchId}`;
    return this.actHttp.get(
      url,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    ).map((res: Response) => res.json().data);
  }

  updateUserSetting(userId: number, request: UserSetting): Observable<any> {
    const url = environment.endpoint.userSetting.replace(':userId', userId.toString());
    return this.actHttp.put(
      url,
      request,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/user/user.service.ts